module.exports = __webpack_public_path__ + "static/media/gallaxy-background-art.4f3b31e4.jpg";